import { render, staticRenderFns } from "./CorretoraExtrato.vue?vue&type=template&id=f40aecf8&scoped=true"
import script from "./CorretoraExtrato.vue?vue&type=script&lang=js"
export * from "./CorretoraExtrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40aecf8",
  null
  
)

export default component.exports